let ProgramChart = function (props) {
  let { programInfo } = props;

  let width = 200;
  let height = 14;
  let schedules = programInfo.schedules;
  let w = Math.min(width, (programInfo.currentDay / programInfo.totalDays) * width) || 0;
  let n = schedules.length;
  let _x = 0;

  let rects = schedules.map(function (s, i) {
    let p = 1.5;
    let w = (width * (s.durationDays / programInfo.totalDays)) - (((n - 1) * p) / n);
    let x = _x;
    let tip = s.displayName + " (" + tx("count_days", { _count: s.durationDays }) + ")";

    _x += w + p;

    return <rect key={i} x={x} width={w} height={height} data-tooltip={tip}/>;
  });

  return (
    <svg width={width} height={height} className="rc-program-chart">
      <defs>
        <mask id="pc_mask">
          {rects}
        </mask>
      </defs>
      {rects}
      <rect width={w} height={height} mask="url(#pc_mask)"/>
    </svg>
  );
};

module.exports = ProgramChart;